import { useControl } from "react-map-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";

export default function DrawControl({ handleCreateComponent }) {
  useControl(
    ({ map }) => {
      const controlGl = new MapboxDraw({
        controls: {
          point: true,
          polygon: false,
          line_string: false,
          combine_features: false,
          uncombine_features: false,
        },
      });
      map.on("load", () => {
        map.addControl(controlGl);
      });
      map.on("draw.create", (e) => {
        const { features } = e;
        const lenFeatures = features.length;
        const lastFeature = features[lenFeatures - 1];
        handleCreateComponent(lastFeature);
      });
    },
    {
      position: "top-left",
    }
  );

  return null;
}
